module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"28PingFangHK400":{"style":{"font-size":"3.7333333333333334vw","font-family":"PingFang HK","font-weight":400}},"pingFangHK400":{"style":{"font-family":"PingFang HK","font-weight":400}}},"en":{"28PingFangHK400":{"style":{"font-size":"4.266666666666667vw"}}},"ja":{"28PingFangHK400":{"style":{"font-size":"3.7333333333333334vw"}}}}')
  delete Component.options._Ctor
}
